import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FiPlus } from "react-icons/fi";
import Header from "../components/Header";
import Footer from "../components/Footer";
import HeroSection from "../components/HeroSection";
import CaseCard from "../components/foundation/CaseCard";
import { CATEGORIES } from "../components/foundation/foundationUtils";
import { apiRequest, fetchFoundationSettings } from "../api";

// Foundation: the admin-managed banner and body, then the approved requests as cards. People in need
// register from the button (their request is reviewed first); helpers open a card and offer help.
export default function FoundationPage() {
  const [settings, setSettings] = useState(null);
  const [cases, setCases] = useState(null);
  const [category, setCategory] = useState("");

  useEffect(() => {
    fetchFoundationSettings().then(setSettings).catch(() => {});
  }, []);

  useEffect(() => {
    setCases(null);
    apiRequest(`/core/foundation/cases/${category ? `?category=${category}` : ""}`).then(({ ok, data }) => setCases(ok ? data : []));
  }, [category]);

  const currency = settings?.currency_label || "PKR";

  return (
    <>
      <Header />
      <div className="h-16" />
      <HeroSection slug="foundation" fallbackTitle="Foundation" />

      <section className="bg-navy-dark text-white py-16">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="text-center max-w-3xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold">{settings?.cases_heading || "People Who Need Your Help"}</h2>
            <p className="text-gray-400 mt-3">{settings?.cases_intro}</p>
            <Link to="/foundation/register" className="inline-flex items-center gap-2 mt-6 px-6 py-3 rounded-full bg-brand-gradient font-semibold shadow-lg shadow-accent/20">
              <FiPlus /> Register Your Need
            </Link>
          </div>

          <div className="flex flex-wrap justify-center gap-2 my-10">
            {[{ key: "", label: "All" }, ...CATEGORIES].map((c) => (
              <button
                key={c.key}
                onClick={() => setCategory(c.key)}
                className={`px-4 py-1.5 rounded-full text-sm font-semibold transition-colors ${
                  category === c.key ? "bg-brand-gradient text-white" : "bg-white/5 border border-navy-border text-gray-300 hover:border-accent-light hover:text-white"
                }`}
              >
                {c.label}
              </button>
            ))}
          </div>

          {cases === null ? (
            <p className="text-center text-gray-500 py-10">Loading...</p>
          ) : cases.length === 0 ? (
            <div className="text-center py-14 rounded-xl bg-navy border border-navy-border">
              <p className="text-lg font-semibold">No requests to show right now</p>
              <p className="text-gray-400 mt-1">{category ? "Try another category." : "Approved requests will appear here."}</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {cases.map((item, i) => <CaseCard key={item.id} item={item} currency={currency} index={i} />)}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </>
  );
}
